import {
  BottomNavigation as MuiBottomNavigation,
  styled,
  BottomNavigationProps,
  BottomNavigationAction,
} from '@mui/material'
import React, { FC } from 'react'

import { IsBottomNavigationItem } from '../interfaces/IsBottomNavigationItem'

const StyledBottomNavigation = styled((props: BottomNavigationProps) => (
  <MuiBottomNavigation showLabels {...props} />
))(({ theme }) => ({
  margin: 10,
  borderRadius: '16px',
  '& .MuiBottomNavigationAction-label.Mui-selected': { fontSize: '12px' },
}))

interface Props {
  items: IsBottomNavigationItem[]
  [otherProps: string]: any
}

const BottomNavigation: FC<Props> = ({ items, ...otherProps }) => {
  return (
    <StyledBottomNavigation {...otherProps} dir='ltr'>
      {items.map((item) => (
        <BottomNavigationAction
          icon={item.icon}
          key={item.id}
          label={item.label}
          sx={{ minWidth: 0 }}
          value={item.value}
        />
      ))}
    </StyledBottomNavigation>
  )
}

export default BottomNavigation
